export const PROFILE_ROUTE = {
  TITLE: 'Profile',
  ABSOLUTE_PATH: '/profile',
  EXACT_PATH: '/profile',
};

export const PUBLIC_PROFILE_ROUTE = {
  TITLE: 'Public Profile',
  ABSOLUTE_PATH: '/public-profile',
  KEY: 'public-profile',
  EXACT_PATH: [PROFILE_ROUTE.ABSOLUTE_PATH, '/public-profile'].join(''),
};
